import Modal from '@mui/material/Modal';
import { BsX } from 'react-icons/bs';

import { useProductSelection } from '../../hook/useProductSelection';
import { formatViewNumber } from '../../utils/utils';
import Button from '../button/button.component';
import SelectItem from './flor-item/select-item.component';
import DescriptionItem from './modal-descriptions/description-flors/description-item';
import './modal-item.styles.scss';

const ModalItem = ({ open, handleClose, product }) => {
  const { totalPrice, selectPrice, productToAdd, addProductToCart } =
    useProductSelection(product);

  const handleAddToCart = () => {
    addProductToCart();
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="modal-item-title">
      <div className="modal-item">
        <button
          className="modal-item-close"
          type="button"
          onClick={handleClose}
          aria-label="Fermer"
        >
          <BsX />
        </button>

        <div className="modal-item-main">
          <div className="modal-item-media">
            <img src={product.imageUrl} alt={product.name} />
          </div>

          <div>
            <p className="modal-item-overline">Fiche produit</p>
            <h2 className="modal-item-title" id="modal-item-title">
              {product.name}
            </h2>

            <SelectItem
              product={product}
              value={totalPrice}
              onSelect={selectPrice}
            />

            <div className="modal-item-total">
              <span className="modal-item-total-label">Total</span>
              <span className="modal-item-total-value">
                {formatViewNumber(totalPrice)} €
              </span>
            </div>

            <Button
              className="modal-item-submit"
              disabled={!totalPrice}
              onClick={handleAddToCart}
            >
              Ajouter au panier
            </Button>
          </div>
        </div>

        <DescriptionItem product={productToAdd} />
      </div>
    </Modal>
  );
};

export default ModalItem;
